import { createFileRoute } from '@tanstack/react-router';
import { ImportPage } from '@/features/crm/pages/import-page';

export const Route = createFileRoute('/_app/settings/services/import')({
  component: () => <ImportPage type="services" />,
});
